export default "__VITE_ASSET__CpcI4a$c__"